// Validación de RUT chileno y teléfonos.

// ---------------------- RUT ----------------------
// Limpia un RUT: deja solo dígitos y K
export function cleanRut(rut) {
  if (!rut) return "";
  return String(rut).replace(/[^0-9kK]/g, "").toUpperCase();
}

// Calcula dígito verificador para un cuerpo numérico
function computeDV(body) {
  let sum = 0;
  let mul = 2;
  for (let i = body.length - 1; i >= 0; i--) {
    sum += parseInt(body[i], 10) * mul;
    mul = mul === 7 ? 2 : mul + 1;
  }
  const mod = 11 - (sum % 11);
  if (mod === 11) return "0";
  if (mod === 10) return "K";
  return String(mod);
}

// Valida estructura + dígito verificador
export function validateRut(rut) {
  const clean = cleanRut(rut);
  if (clean.length < 8 || clean.length > 9) return false;
  const body = clean.slice(0, -1);
  const dv = clean.slice(-1);
  if (!/^\d+$/.test(body)) return false;
  return computeDV(body) === dv;
}

// Formatea como 12.345.678-9
export function formatRut(rut) {
  const clean = cleanRut(rut);
  if (clean.length < 2) return clean;
  const body = clean.slice(0, -1);
  const dv = clean.slice(-1);
  const formattedBody = body.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  return `${formattedBody}-${dv}`;
}

// ---------------------- Phone (Chile) ----------------------
// Acepta formatos: +56912345678, 56912345678, 912345678, +56 9 1234 5678
// Móvil chileno: 9 dígitos empezando con 9 (después del código país +56)
export function cleanPhone(phone) {
  if (!phone) return "";
  return String(phone).replace(/[^\d+]/g, "");
}

export function validatePhone(phone) {
  if (!phone) return false;
  const clean = cleanPhone(phone).replace(/^\+/, "");
  // Forma normalizada: 56 9XXXXXXXX (11) o 9XXXXXXXX (9)
  if (clean.length === 9 && clean.startsWith("9")) return true;
  if (clean.length === 11 && clean.startsWith("569")) return true;
  // Acepta fijo chileno: 9 dígitos comenzando con 2 (regional) — opcional, lo dejamos para flexibilidad
  if (clean.length === 9 && /^[2-7]/.test(clean)) return true;
  return false;
}

export function formatPhone(phone) {
  const clean = cleanPhone(phone).replace(/^\+/, "");
  if (clean.length === 11 && clean.startsWith("569")) {
    return `+56 9 ${clean.slice(3, 7)} ${clean.slice(7)}`;
  }
  if (clean.length === 9 && clean.startsWith("9")) {
    return `+56 9 ${clean.slice(1, 5)} ${clean.slice(5)}`;
  }
  if (clean.length === 9) {
    return `+56 ${clean.slice(0, 1)} ${clean.slice(1, 5)} ${clean.slice(5)}`;
  }
  return phone;
}
